<template>
    <div :class="fieldClass">
        <template v-if="field.type === 'textarea'">
            <label :for="field.name" v-if="field.showLabel !== false">{{ fieldLabel }}</label>
            <textarea
                    @input="onInput"
                    :id="field.name"
                    :name="field.name"
                    :value="newValue"
                    :required="field.required"
                    :placeholder="fieldLabel">
            </textarea>
        </template>
        <template v-else>
<!--            <label :for="field.name" v-if="field.showLabel !== false">{{ fieldLabel }}</label>-->
<!--            <input-->
<!--                    @input="onInput"-->
<!--                    :value="newValue"-->
<!--                    :placeholder="fieldLabel"-->
<!--                    :type="field.type ? field.type : 'text'"-->
<!--                    :required="field.required"-->
<!--                    :id="field.name">-->
<!--            <p >s{{ start }}</p>-->
<!--            <div class="form-group" >-->
<!--&lt;!&ndash;                <label for="sel1">Select list:</label>&ndash;&gt;-->
<!--                <select class="form-control" v-model="timeFrameInput" @change="onChange($event)">-->
<!--                    <option>15</option>-->
<!--                    <option>30</option>-->
<!--                    <option>45</option>-->
<!--                    <option></option>-->
<!--                </select>-->
<!--            </div>-->
<!--            <p >e{{ end }}</p>-->
<!--            <vue-timepicker-->
<!--                    manual-input-->
<!--                    @input="onInput($event)"-->
<!--                    v-if="idx === 1 &&-->
<!--          field.type !== 'date' &&-->
<!--            field.type !== 'select' &&-->
<!--            field.type !== undefined-->
<!--        "-->
<!--                    :minute-interval="15"-->
<!--                    v-model="timeFrameInputValue" format="mm"-->
<!--                    :placeholder="fieldLabel"-->
<!--                    :type="field.type ? field.type : 'text'"-->
<!--                    :id="field.name"-->
<!--                    input-width="60px"-->
<!--                    hide-disabled-minutes-->
<!--                    :minute-range="[15, 30, 45]"-->
<!--            ></vue-timepicker>-->
<!--            <vue-timepicker-->
<!--                    manual-input-->
<!--                    @input="onInput($event)"-->
<!--                    v-if="idx === 0 &&-->
<!--          field.type !== 'date' &&-->
<!--            field.type !== 'select' &&-->
<!--            field.type !== undefined-->
<!--        "-->
<!--                    :minute-interval="15"-->
<!--                    v-model="firstInputTimeValue"-->
<!--                    format="HH:mm"-->
<!--                    :placeholder="fieldLabel"-->
<!--                    :type="field.type ? field.type : 'text'"-->
<!--                    :id="field.name"-->
<!--                    input-width="100px"-->
<!--            ></vue-timepicker>-->
<!--            <vue-timepicker-->
<!--                    manual-input-->
<!--                    @input="onInput($event)"-->
<!--                    v-if="idx === 1 &&-->
<!--          field.type !== 'date' &&-->
<!--            field.type !== 'select' &&-->
<!--            field.type !== undefined-->
<!--        "-->
<!--                    :minute-interval="15"-->
<!--                    v-model="secondInputTimeValue"-->
<!--                    format="HH:mm"-->
<!--                    :placeholder="fieldLabel"-->
<!--                    :type="field.type ? field.type : 'text'"-->
<!--                    :id="field.name"-->
<!--                    input-width="100px"-->
<!--            ></vue-timepicker>-->
        </template>
    </div>
</template>

<script>
    import moment from 'moment';
    import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";


    export default {
        name: "EventDialogInput",
        // components: { VueTimepicker },

        props: {
            value: [ Date, String, Number, Boolean, Array, Object ],
            field: {
                type: Object,
                required: true
            },
            idx: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                newValue: this.value,
                firstInputTimeValue: {
                    HH: moment(this.value).format('HH'),
                    mm: moment(this.value).format('mm'),
                },
                secondInputTimeValue: {
                    HH: moment(this.value).subtract(1,'hour').format('HH'),
                    mm: moment(this.value).add(15,'minutes').format('mm'),
                },
                timeFrameInputValue: {
                    HH: moment(this.value).format('HH'),
                    mm: moment(this.value).add(15,'minutes').format('mm'),
                },
                timeFrameInput:15,
                start:null,
                end: null
            }
        },
        beforeMount() {
            //  Date workaround
            if ( this.field.type === 'date' && this.value ) {
                this.newValue = moment(this.value).format().slice(0, 10);
            }

            //  Time workaround
            if ( this.field.type === 'time' && this.value ) {
                this.newValue = moment(this.value).format().slice(11, 16);
            }
        },
        methods: {
            onChange(event) {
                this.end = moment(this.value).subtract(15,'minutes').add(event.target.value, 'minutes').format('hh:mm')


            },
            onInput(event) {
                if(this.idx ===0){
                    this.newValue = `${this.firstInputTimeValue.HH}:${this.firstInputTimeValue.mm}`
                }
                if(this.idx ===1){
                    this.newValue = `${this.secondInputTimeValue.HH}:${this.secondInputTimeValue.mm}`
                }
                this.secondInputTimeValue.mm = moment(this.value).subtract(1,'hour').add(event.mm, 'minutes').format('mm')
                this.$nextTick(() => {
                    // this.newValue = event.target.value
                });
            }
        },
        watch: {
            value(value) {
                this.newValue = value;
            },
            newValue(value) {
                let res = value;

                if ( this.field.type === 'time' ) {
                    res = moment(this.newValue, "HH:mm");
                }

                this.$emit('input', res);
            }
        },
        computed: {
            isCheckOrRadio() {
                return this.field.type === 'radio' || this.field.type === 'checkbox';
            },
            fieldLabel() {
                return this.field.label ? this.field.label : this.field.name;
            },
            fieldClass() {
                if ( this.overrideInputClass )
                    return this.inputClass;

                let classes = [
                    'v-cal-input',
                    this.inputClass
                ];

                if ( this.isCheckOrRadio ) {

                    if ( !this.field.choices ) {
                        classes.push('is-inline');
                        classes.push('is-' + this.field.type);
                    } else {
                        classes.push('v-cal-input-group');
                    }
                }

                return classes.join(' ');
            }
        },
        mounted() {
            if(this.idx==0){
                this.start=this.value.format('hh:mm')
                this.end=this.value.add(15, 'minutes').format('hh:mm')
            }
            if(this.idx==1){
                this.start=this.value.format('hh:mm')
                this.end=this.value.add(15, 'minutes').format('hh:mm')
            }

        }
    }
</script>

<style scoped>

</style>